// src/lib/referrals/referrals.js

const REFERRAL_STORAGE_KEY = "gwin_referral_code";

function normalizeReferralCode(value) {
  return String(value || "").trim().toUpperCase();
}

export function captureReferralCodeFromUrl() {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search);
  const code = params.get("ref") || params.get("referral") || params.get("invite") || "";
  const normalizedCode = normalizeReferralCode(code);
  if (!normalizedCode) return "";
  try { localStorage.setItem(REFERRAL_STORAGE_KEY, normalizedCode); } catch {}
  return normalizedCode;
}

export function getStoredReferralCode() {
  if (typeof window === "undefined") return "";
  try { return normalizeReferralCode(localStorage.getItem(REFERRAL_STORAGE_KEY)); } catch { return ""; }
}

export function clearStoredReferralCode() {
  if (typeof window === "undefined") return;
  try { localStorage.removeItem(REFERRAL_STORAGE_KEY); } catch {}
}

export async function claimStoredReferralCode(supabase) {
  if (!supabase) throw new Error("Supabase client is required.");
  const code = getStoredReferralCode();
  if (!code) return { claimed: false, reason: "missing_code" };
  const { data, error } = await supabase.rpc("claim_referral_code", { input_code: code });
  if (error) throw error;
  if (data?.claimed || data?.reason === "already_claimed" || data?.reason === "self_referral_not_allowed" || data?.reason === "invalid_code") {
    clearStoredReferralCode();
  }
  return data;
}

export async function getMyReferralSummary(supabase) {
  if (!supabase) throw new Error("Supabase client is required.");
  const { data, error } = await supabase.rpc("get_my_referral_summary");
  if (error) throw error;
  return data;
}

export async function getReferralMonthAccess(supabase) {
  if (!supabase) throw new Error("Supabase client is required.");
  const { data, error } = await supabase.rpc("get_my_referral_month_access");
  if (error) throw error;
  return {
    active: data?.active === true,
    startsAt: data?.starts_at || null,
    expiresAt: data?.expires_at || null,
    qualifiedReferrals: Number(data?.qualified_referrals || 0),
    requiredReferrals: Number(data?.required_referrals || 5),
    source: data?.active === true ? "referral_month_access" : null,
  };
}

export async function hasReferralPaid50Access(supabase) {
  const result = await getReferralMonthAccess(supabase);
  return result.active === true;
}

export function buildReferralInviteLink(code) {
  const normalizedCode = normalizeReferralCode(code);
  if (!normalizedCode) return "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/register?ref=${encodeURIComponent(normalizedCode)}`;
}
